import TextUtil from '@sas-dvr/ltjs-commons/util/TextUtil';
// 0.5rem padding + 2px for border
export const ItemHeightPadding = 0.5 * 16 + 2;
export function filterUndefined(item) {
    const newItem = {};
    for (const key of Object.keys(item)) {
        const value = item[key];
        if (value !== undefined) {
            newItem[key] = value;
        }
    }
    return newItem;
}
export function listStyleTokenOverrides(props, style) {
    if (!style) {
        return undefined;
    }
    if (props.state === 'normal') {
        return style.normal;
    }
    const fg = style.normal ? style.normal.fg : undefined;
    const bg = style.normal ? style.normal.bg : undefined;
    return filterUndefined({
        fg,
        bg: bg ? 'initial' : undefined,
    });
}
export function fontStyles(font, dt) {
    return Object.assign({ fontFamily: dt.reportTokens.font.family.default, fontSize: dt.reportTokens.font.size.m, fontWeight: 'normal', fontStyle: 'normal' }, font);
}
export function textHeight(style) {
    return TextUtil.getTextHeightFromStyle(style);
}
export function textWidth(value, style) {
    return TextUtil.getTextWidthFromComputedStyle(value, style);
}
export function longestTextWidthForValues(values, measureValues, style) {
    return longestTextWidth(measureValues ? values.map((value, i) => { var _a; return (_a = value + measureValues[i]) !== null && _a !== void 0 ? _a : ''; }) : values, style);
}
export function longestTextWidth(values, style) {
    if (!values) {
        return 0;
    }
    return TextUtil.getTextWidthFromComputedStyle(values, style);
}
export function totalTextWidth(values, style) {
    if (!values) {
        return 0;
    }
    return values.reduce((previous, value) => TextUtil.getTextWidthFromComputedStyle(value, style) + previous, 0);
}
